import { Typography } from "antd";
import { cx } from "class-variance-authority";

import * as backgrounds from "./backgrounds.css";
import * as theme from "./SectionHeader.css";
import { SectionBackgroundVariant, SectionLevel } from "./types";

const { Title } = Typography;

const headerBackgroundVariantMap: Record<SectionBackgroundVariant, string> = {
    default: backgrounds.defaultBackground,
    active: backgrounds.activeHeaderBackground,
    readOnly: backgrounds.readOnlyHeaderBackground,
};

interface SectionHeaderProps {
    titleLabel: React.ReactNode;
    subtitleLabel?: React.ReactNode;
    rightChildren?: React.ReactNode;
    level: SectionLevel;
    backgroundVariant?: SectionBackgroundVariant;
    showBorder?: boolean;
    bottomBorderRadius?: boolean;
    onClick?: () => void;
}

export function SectionHeader({
    titleLabel,
    subtitleLabel,
    rightChildren,
    level,
    backgroundVariant = "default",
    showBorder = false,
    bottomBorderRadius = false,
    onClick,
}: SectionHeaderProps) {
    const rootClasses = cx(
        theme.sectionHeader,
        headerBackgroundVariantMap[backgroundVariant],
        showBorder && theme.sectionHeaderBorder,
        bottomBorderRadius && theme.sectionHeaderCollapsed,
        onClick && theme.sectionHeaderClickable
    );
    return (
        <div className={rootClasses} onClick={onClick}>
            <div className={theme.sectionHeaderContents}>
                <div className={theme.sectionHeaderTitleGroup}>
                    <Title className={theme.sectionHeaderTitle} level={level}>
                        {titleLabel}
                    </Title>
                    {subtitleLabel && (
                        <div className={theme.sectionHeaderSubtitle}>
                            {subtitleLabel}
                        </div>
                    )}
                </div>
                {rightChildren && (
                    <div onClick={(e) => e.stopPropagation()}>
                        {rightChildren}
                    </div>
                )}
            </div>
        </div>
    );
}
